import { useState, useEffect } from 'react';
import fetchPartnerDetails from '../../../services/fetchPartnerDetails';

export default function usePartnerDetails(partnerId) {
  const [ isPartnerDetailsFetchingInProgress, setIsPartnerDetailsFetchingInProgress ] = useState(false);
  const [ hasPartnerDetailsFetchingError, setHasPartnerDetailsFetchingError ] = useState(null);
  const [ partnerDetails, setPartnerDetails ] = useState(null);

  useEffect(
    () => {
      async function loadPartnerDetails() {
        if(!!partnerId) {
          const cleanedUpSiteId = `${partnerId}`.replace(/[^0-9]+/g,'');
          const partnerDetailsData = await fetchPartnerDetails(cleanedUpSiteId);
          if(!partnerDetailsData.hasError) {
            setHasPartnerDetailsFetchingError(null);
            setPartnerDetails(previousValue => partnerDetailsData.foundPartner);
            setIsPartnerDetailsFetchingInProgress(false);
          }
          else {
            setHasPartnerDetailsFetchingError(partnerDetailsData.errorMessage);
            setPartnerDetails(null);
            setIsPartnerDetailsFetchingInProgress(false);
          }
        }
      }
      setIsPartnerDetailsFetchingInProgress(true);
      loadPartnerDetails();
    },
    [partnerId]
  );

  return { isPartnerDetailsFetchingInProgress, hasPartnerDetailsFetchingError, partnerDetails};
}

